import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-20 flex flex-col md:flex-row md:p-0 md:items-center" }
const _hoisted_2 = { class: "w-full pt-15 break-words pb-15 md:pt-0 md:px-40 md:w-1/3 lg:px-60" }
const _hoisted_3 = {
  key: 0,
  class: "o-text-caption uppercase m-0"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "relative md:w-2/3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CMSLinkHandler = _resolveComponent("CMSLinkHandler")!
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.content.subTitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.content.subTitle), 1))
        : _createCommentVNode("", true),
      (_ctx.content.title)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.content.title), 1))
        : _createCommentVNode("", true),
      (_ctx.content.text)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "my-10",
            innerHTML: _ctx.content.text
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true),
      (_ctx.content.link)
        ? (_openBlock(), _createBlock(_component_CMSLinkHandler, {
            key: 3,
            "link-block": _ctx.content.link,
            class: "mt-15 md:mt-25 max-w-full"
          }, null, 8, ["link-block"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createVNode(_component_VideoPlayer, {
        url: _ctx.videoUrl,
        poster: _ctx.videoPoster,
        onVideoPlay: _ctx.trackVideoStart,
        onVideoEnded: _ctx.trackVideoEnd,
        onVideoProgress: _ctx.trackVideoProgress
      }, null, 8, ["url", "poster", "onVideoPlay", "onVideoEnded", "onVideoProgress"])
    ])
  ]))
}